<script>
  import { Router, Route } from "svelte-routing";
  import Index1 from "./routes/Index.svelte";
  export let url = "";
</script>

<Router {url}>
  <div>
    <Route path="/"><Index1 /></Route>
  </div>
</Router>
